module.exports = __webpack_public_path__ + "img/block_bg01.2b980950.webp";